import { fetch as fetchAPI } from '@lingoking-node-apps/api'
import { useRequestStateStore } from '@/stores/request-state'
import { getParams } from './params'

export const fetch = (
  url: string,
  options?: null | {
    method?: string
    data?: any
    ignoreSwitchUser?: boolean
    responseType?: string
  },
  loading: boolean = true
) => {
  const requestState = useRequestStateStore()

  return new Promise<any>((resolve, reject) => {
    if (loading) {
      requestState.loading = true
    }

    requestState.error = null

    fetchAPI(url, options)
      .then((response: any) => {
        requestState.loading = false
        resolve(response)
      })
      .catch((error: null) => {
        requestState.loading = false
        requestState.error = error
        reject(error)
      })
  })
}

export const fetchEntity = (
  url: string,
  options?: { method?: string; data?: string; ignoreSwitchUser?: boolean }
) => {
  const requestState = useRequestStateStore()

  return new Promise<any>((resolve, reject) => {
    requestState.loading = true
    requestState.error = null

    fetchAPI(url, options)
      .then((response: any) => {
        requestState.loading = false
        resolve(response['hydra:member'])
      })
      .catch((error: null) => {
        requestState.loading = false
        requestState.error = error
        reject(error)
      })
  })
}

export type FetchDataResponse<T> = {
  '@context': string
  '@id': string
  '@type': 'hydra:Collection'
  'hydra:member': Array<T>
  'hydra:totalItems': number
  'hydra:view': any
  'hydra:search': any
}

export const fetchData = async <T>(
  url: string,
  filters: Record<string, string | number | boolean | Array<string>>,
  sort: Record<string, 'ASC' | 'DESC'> | null,
  groups: Array<string>
): Promise<FetchDataResponse<T>> => {
  const params: Array<Record<string, string | number | boolean>> = [
    ...groups.map((group) => ({ 'groups[]': group }))
  ]

  Object.keys(filters).forEach((filterName: string) => {
    if (filters[filterName] instanceof Array) {
      filters[filterName].forEach((filterValue) => params.push({ [filterName]: filterValue }))
    } else {
      params.push({ [filterName]: filters[filterName] })
    }
  })

  if (sort) {
    const param: any = {}
    Object.keys(sort).forEach((key) => {
      param[`order[${key}]`] = sort[key]
    })

    params.push(param)
  }

  // params:
  const searchParams = getParams(params)

  if (searchParams.size) {
    url += '?' + searchParams.toString()
  }

  return await fetch(url)
}
